import { TMBoardId } from './TimeMaterialBoardResponse';

export enum TMStageType {
  estimate = 'estimate',
  invoice = 'invoice',
  order = 'order',
  shipped = 'shipped',
  acknowledge = 'acknowledge',
  delivered = 'delivered',
  custom = 'custom',
}

export type TMStageId = string;
export interface TMStageResponse {
  id: TMStageId;
  name: string;
  emails: string;
  description: string;

  type: TMStageType;
  menuOrder: number;
  canDelete: boolean;
  active: boolean;
  boardId: TMBoardId;
}
